export const numberFormatter = new Intl.NumberFormat("en-US");

export default numberFormatter;
